import React, { useEffect, useState } from "react";
import { getDashboardStats } from "../services/smsDataApi";
import "./smsForm.css";
import "./Dashboard.css";

function Dashboard({ user }) {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [isCustomRange, setIsCustomRange] = useState(false);

    useEffect(() => {
        loadStats();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadStats = async (from = fromDate, to = toDate) => {
        setLoading(true);
        try {
            const res = await getDashboardStats(from, to);
            setStats(res);
        } catch (err) {
            console.error("Failed to load dashboard stats", err);
        } finally {
            setLoading(false);
        }
    };

    const handleFilter = () => {
        setIsCustomRange(true);
        loadStats(fromDate, toDate);
    };

    const handleReset = () => {
        setFromDate("");
        setToDate("");
        setIsCustomRange(false);
        loadStats(null, null);
    };

    const rangeLabel = stats
        ? isCustomRange
            ? `${stats.fromDate} → ${stats.toDate}`
            : "Today"
        : "";

    const rangeCards = stats ? [
        { label: "SMS Sent", value: stats.rangeSms, icon: "🚀", color: "#1abc9c" },
        { label: "Successful", value: stats.rangeSuccess, icon: "✅", color: "#16a085" },
        { label: "Failed", value: stats.rangeFailed, icon: "⚠️", color: "#e74c3c" },
    ] : [];

    return (
        <div className="page">

            {/* HEADER + FILTER */}
            <div className="header-card dashboard-header">
                <div className="dashboard-header-top">
                    <div>
                        <h2>Welcome back, {user?.username} 👋</h2>
                        <p>Here's what's happening with your SMS console.</p>
                    </div>

                    <div className="dashboard-date-filter">
                        <input
                            type="date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                        />
                        <span className="date-sep">→</span>
                        <input
                            type="date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                        />
                        <button className="filter-btn apply" onClick={handleFilter}>
                            Apply
                        </button>
                        {isCustomRange && (
                            <button className="filter-btn reset" onClick={handleReset}>
                                Today
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {loading ? (
                <p style={{ color: "#8a94a6" }}>Loading stats...</p>
            ) : (
                <>
                    {/* ALL-TIME TOTAL */}
                    <div className="card total-card">
                        <div className="total-icon">📨</div>
                        <div className="total-info">
                            <span className="total-value">{stats?.totalSms?.toLocaleString()}</span>
                            <span className="total-label">Total SMS Sent (All Time)</span>
                        </div>
                    </div>

                    {/* RANGE STATS */}
                    <div className="range-header">
                        <h3>{rangeLabel}</h3>
                    </div>

                    <div className="stat-grid">
                        {rangeCards.map((s, i) => (
                            <div className="stat-card" key={i}>
                                <div className="stat-icon" style={{ background: s.color + "22", color: s.color }}>
                                    {s.icon}
                                </div>
                                <div className="stat-info">
                                    <span className="stat-value">{s.value?.toLocaleString()}</span>
                                    <span className="stat-label">{s.label}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}

export default Dashboard;